<head>
  <title>Add Document Component</title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<script>
  // Use datepicker on the date inputs
  $("input[type=date]").datepicker({
    dateFormat: "dd-mmm-yyyy",
    onSelect: function (dateText, inst) {
      console.log($(inst).val(dateText), inst, dateText), $(inst).val(dateText); // Write the value in the input
    },
  });

  // Code below to avoid the classic date-picker
  $("input[type=date]").on("click", function () {
    return false;
  });
</script>
<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="">
  <div class="log_data_bg">
    <div class="log_data" *ngIf="documentData.documentId != null">
      <span>
        Document > Repository > {{documentData.folderPath}} - {{ documentData.documentNo }}({{
        documentData.version
        }})</span>
      &nbsp;&nbsp;
      <span *ngIf="viewAssociatedDoc" style="color: blue; text-decoration: underline; cursor: pointer"
        (click)="backToViewMainDoc()">View Main Document</span>
    </div>
  </div>
  <div *ngIf="viewAssociatedDoc">
    <span>
      Document > Repository > {{clickedDoc.folderPath}} -
      <b>{{ clickedDoc.documentTypeName }} - </b>
      <span>{{ clickedDoc.documentNo }}({{ clickedDoc.version }}) - </span>
      &nbsp;&nbsp;
    </span>
  </div>
  <div class="pull-right" style="margin-top: -1%;" *ngIf="documentData.documentId != null">
    <span [ngClass]="documentData.status == 'Inactive' ||
    documentData.status == 'Locked' ||
    documentData.status == 'Expired' ||
    documentData.status == 'Approval Rejected' ||
    documentData.status == 'Review Rejected' ||
    documentData.status.includes('Requested More Info.') ||
    documentData.status.includes('Expired') ||
    documentData.status.includes('Inactive') ||
    documentData.status == 'Signoff Rejected' ||
    documentData.status == 'Obsoleted' ||
    documentData.status == 'Deleted' ? 'delete' :
    documentData.status == 'Withdrawn' ? 'withdraw' : documentData.status == 'Active' ? 'approve' : documentData.status == 'Open' ||
    documentData.status == 'Draft' ||
    documentData.status == 'Pending Review' ||
    documentData.status == 'Pending Approval' ||
    documentData.status.includes('Inprogress') ||
    documentData.status == 'Pending Publish' ||
    documentData.status == 'Pending Signoff' ? 'draft' :  documentData.status == 'Published' ||
    documentData.status.includes('Completed') ? 'closed' :''">{{ documentData.status }}</span>
    <span *ngIf="documentData.status == 'Place Holder'" style="color: purple">({{ documentData.status }})
    </span>
  </div>
</div>

<div class="border my-3">
  <div class="d-flex justify-content-between p-3">
    <div>
      <p class="preview">Preview</p>
    </div>
    <div class="d-flex gap-3">
      <div class="d-flex gap-3 pull-right button-continer">
        <mat-checkbox *ngIf="documentData.status =='Published' && !this.viewAssociatedDoc"
          [(ngModel)]="isCoverpageEnable" (change)="onCoverPageCheckboxChanged($event)">View
          Document With Cover Page</mat-checkbox>
        <button *ngIf="saveButtonForDocument" style="margin-right: 10px" mat-stroked-button class="addButton"
          (click)="saveDocument('Main')">
          Save
        </button>
        <div class="d-flex gap-3" *ngFor="let button of buttonLabels">
          <span class="button-continer" *ngIf="buttonLabels != ''">
            <button *ngIf="button != 'Cancel' && button != ''" class="addIconContiner text-white px-4 reload_text"
              (click)="dynamicButtonClick(button)">
              {{ button }}
            </button>
          </span>
        </div>
        <button *ngIf="appService.prevDocumentId == null" mat-stroked-button class="cancelButton" (click)="back()">
          Cancel
        </button>
        <button *ngIf="appService.prevDocumentId != null" mat-stroked-button class="cancelButton"
          (click)="backToMainDoc()">
          Back
        </button>


        <div *ngIf="message.isTopicAdministrator" class="document_feature_block">
          <img matTooltip="Communication" src="../../../assets/img/DMS/communication.svg" width="18px" height="18px"
            alt="communication" (click)="openTopicPopup()" />
        </div>

        <div class="document_feature_block">
          <img matTooltip="Expand/Collapse" src="../../../assets/img/DMS/collapse.svg" width="18px" height="18px"
            alt="collapse" (click)="sideBarExpandCollpaseFunc()" />
        </div>
      </div>

    </div>
  </div>

  <div class="row mb-2" *ngIf="instructions != null">
    <p style="text-align: right; margin-bottom: 0px">
      <i>{{ instructions }}</i>
    </p>
  </div>

  <div class="row" style="margin-left: 0px; margin-right: 0px">
    <div [ngClass]="isSideBarCollapsed ? 'col-md-12' : 'col-md-6'" style="height: 82vh; right: 5px; left: 5px">
      <div *ngIf="documentData.onlineEditorMode != null && documentData.status == 'Draft'"
        style="color: black; text-align: center; margin-top: 25%">
        Mode: <span>{{documentData.onlineEditorMode}}</span>
        <br>
        <a href="{{documentData.onlineEditorCrLink ? documentData.onlineEditorCrLink : documentData.onlineEditorCaLink}}"
          target="_blank">
          {{documentData.onlineEditorCrLink ? documentData.onlineEditorCrLink : documentData.onlineEditorCaLink}}
        </a>
      </div>
      <div id="isNotViewableFile">
        <div class="row" *ngIf="showuploaddiv && saveButtonForDocument">
          <label class="control-label col-sm-3" style="margin-top: 4px" for="email"><b>Uploaded File Name : </b>
          </label>
          <div class="col-sm-5" style="margin-top: 4px; margin-left: -5%">
            {{ previousFileName }}
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-md-10">
                <button *ngIf="showuploaddiv && documentData.opern != 'View'" style="margin-top: 1%" class="addButton"
                  mat-stroked-button (click)="closepdfviwer()">
                  Upload Different File
                </button>
              </div>
              <div class="col-md-2" style="padding-left: 0px">
                <a href="" *ngIf="showuploaddiv && documentData.opern != 'View'" style="margin-top: 1%"
                  (click)="downloadtemplate($event)">Download</a>
              </div>
            </div>
          </div>
        </div>
        <div id="viewerHideShow">
          <div [hidden]="!isShowViewer" #viewer style="height: 75vh; margin-top: 5px"> </div>
          <div class="row" style="padding: 5px" *ngIf="!isShowViewer">
            <div class="col-sm-12">
              <img id="picture" src="" height="80vh" width="100%" style="overflow: hidden; height: 80vh; width: 100%" />
            </div>
          </div>
        </div>
        <div *ngIf="!showuploaddiv && documentData.opern != 'View'">
          <input type="file" class="file-input outPopUp" accept={{allowedFileExtns}} (change)="onFileSelected($event)"
            #fileUpload />
          <div class="progress" *ngIf="uploadProgress">
            <div class="progress-bar" [style.width]="uploadProgress + '%'">{{uploadProgress}}%</div>
          </div>
        </div>
      </div>
      <div *ngIf="isViewableFile && documentData.onlineEditorMode == null">
        <div class="row" *ngIf="isShowToUploadDiffFile && saveButtonForDocument">
          <label class="control-label col-sm-3" style="margin-top: 4px" for="email"><b>Uploaded File Name : </b>
          </label>
          <div class="col-sm-5" style="margin-top: 4px; margin-left: -5%">
            {{ previousFileName }}
          </div>
          <div class="col-sm-4">
            <button *ngIf="isShowToUploadDiffFile && documentData.opern != 'View'" style="margin-top: 1%"
              class="addButton" mat-stroked-button (click)="closepdfviwer()">
              Upload Different File
            </button>
          </div>
        </div>
        <div *ngIf="!isShowToUploadDiffFile && documentData.opern != 'View'">
          <input type="file" class="file-input outPopUp" accept={{allowedFileExtns}} (change)="onFileSelected($event)"
            #fileUpload />
          <div class="progress" *ngIf="uploadProgress">
            <div class="progress-bar" [style.width]="uploadProgress + '%'">{{uploadProgress}}%</div>
          </div>
        </div>
        <div class="text-center" *ngIf="isDocumentSaved" style="color: black; text-align: center; margin-top: 25%">
          The file format ({{ documentData.documentExtn }}) is not in supported
          viewable format. To view the file, please download and view.
        </div>

        <div class="text-center" *ngIf="!isDocumentSaved" style="color: black; text-align: center; margin-top: 25%">
          Your file is successfully uploaded. However, you will not be able to
          view the content within this platform. To do that, please save the
          document, download and view it from your local system.
        </div>
        <button *ngIf="isDocumentSaved" type="submit"
          style="margin-top: 1px; margin-bottom: 1px; margin-left: 40%;color:white;" class="addIconContiner"
          (click)="downloadDocument()">
          Download
        </button>
      </div>
    </div>
    <div [hidden]="isSideBarCollapsed" class="col-md-6" style="height: 82vh; right: 5px; left: 5px">
      <div class="tab">
        <mat-tab-group selectedIndex="0" mat-stretch-tabs class="trainingtab mat-tab-container mat-elevation-z4"
          animationDuration="0ms" (selectedTabChange)="onTabChanged($event)" [(selectedIndex)]="selectedTabIndex">
          <mat-tab label="Document Details">
            <ng-template mat-tab-label>
              <span [ngClass]="{'active': selectedTabIndex == 0}">
                Document Details

              </span>
            </ng-template>
            <div class="p-3">
              <div class="row">
                <div class="col-md-6" *ngIf="isDocumentNoManually || documentData.documentId != null">
                  <div><label for="email ">Document No.</label><span *ngIf="isDocumentNoManually"
                      class="mandatory-symbol">*</span></div>
                  <input id="documentNo" class="input-filed-continers" type="text" [(ngModel)]="documentData.documentNo"
                    [disabled]="documentData.documentId != null " />
                  <span *ngIf="
                      documentData.documentNo == '' && onclickedSaveButton && isDocumentNoManually
                    " id="documentNo-required-msg" style="display: block">Please enter a document Number</span>
                </div>
                <div class="col-md-6" *ngIf="isVersionManually || documentData.documentId != null">
                  <div><label for="email ">Version</label><span *ngIf="isVersionManually"
                      class="mandatory-symbol">*</span></div>
                  <input id="version" class="input-filed-continers" type="number" [(ngModel)]="documentData.version"
                    [disabled]="
                      documentData.documentId != null 
                    " (keypress)="validateVersion($event)" />
                  <span *ngIf="
                      documentData.version == '' && onclickedSaveButton && isVersionManually
                    " id="version-required-msg" style="display: block">Please enter a document version</span>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-6">
                  <div>
                    <label for="email ">Document Name</label><span class="mandatory-symbol">*</span>
                  </div>
                  <input id="documentName" class="input-filed-continers" type="text"
                    [(ngModel)]="documentData.documentName" [disabled]="saveButtonForDocument == false" />
                  <span *ngIf="
                      documentData.documentName == '' && onclickedSaveButton
                    " id="documentName-required-msg" style="display: block">Please enter a document name</span>
                </div>
                <div class="col-md-6">
                  <div>
                    <label for="email">Document Type</label><span class="mandatory-symbol">*</span>
                  </div>
                  <mat-select matInput placeholder="Select" [(ngModel)]="selectedDocumentType"
                    (closed)="documentTypeSearchText=''" (click)="focusSearch('focus-doc-type-search')"
                    [disabled]="documentData.documentId != null">
                    <input type="search" id="focus-doc-type-search" class="dropdownsearchstyle"
                      [(ngModel)]="documentTypeSearchText" matInput placeholder="search">
                    <mat-option class="unselectStyle" [value]="null"
                      (onSelectionChange)="ondocumentTypeSelect($event,null)">Un-select</mat-option>
                    <mat-option *ngFor="let item of documentTypeDropdown | assessmentSearch : documentTypeSearchText"
                      [value]="item.valueExp" (onSelectionChange)="ondocumentTypeSelect($event,item)">
                      {{ item.displayExp }}
                    </mat-option>
                  </mat-select>
                  <span *ngIf="
                      selectedDocumentTypeValue == '' && onclickedSaveButton
                    " id="documentType-required-msg" style="display: block">Please enter a document type</span>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-6" *ngIf="
                    documentData.templateName != null ||
                    documentData.templateName != undefined
                  ">
                  <div><label for="email ">Template Name</label></div>
                  <input id="templateName" class="input-filed-continers" type="text"
                    [(ngModel)]="documentData.templateName" disabled />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-6">
                  <div><label for="email">Effective From Date:</label></div>
                  <div>
                    <input type="text" class="form-control data-picker-continer" bsDatepicker
                      [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                      [disabled]="saveButtonForDocument == false" [(ngModel)]="documentData.effectiveDate"
                      (ngModelChange)="
                      selectExpValue(
                        documentData.effectiveDate
                      )
                    " />
                  </div>
                </div>
                <div class="col-md-6" *ngIf="isShowExpDate">
                  <div><label for="email">Expiration Date:</label></div>
                  <div>
                    <input type="text" class="form-control data-picker-continer" bsDatepicker
                      [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                      [disabled]="saveButtonForDocument == false" [disabled]="!isOverrideExpDate"
                      [disabled]="documentData.status != 'Pending Publish' || documentData.status != 'Draft'"
                      [(ngModel)]="documentData.expirationDate" [minDate]="documentData.effectiveDate"
                      [maxDate]="tempDateExpiration" />
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-12">
                  <div>
                    <label for="email ">Document Description</label><span class="mandatory-symbol">*</span>
                  </div>
                  <textarea id="description" rows="4" class="input-filed-textarea" type="text"
                    [(ngModel)]="documentData.documentDescription"
                    [disabled]="saveButtonForDocument == false"></textarea>
                  <span *ngIf="
    (!documentData.documentDescription || documentData.documentDescription.trim() === '') &&
    onclickedSaveButton
  " id="description-required-msg" style="display: block">Please enter description</span>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-12" *ngIf="isShowAssociatedDocumentField">
                  <div><label for="email ">Link to Parent Document</label></div>
                  <div *ngIf="saveButtonForDocument" class="col-md-6" style="padding-left: 5px">
                    <div class="row dms-search-container" style="margin-bottom: 1%">

                      <input id="userName" class="form-control" type="text" placeholder="Link to Parent Document"
                        [(ngModel)]="documentData.associatedDocumentName" (click)="searchDocumentFunction()" />
                    </div>

                  </div>
                  <div *ngIf="!saveButtonForDocument"><a href=""
                      (click)="openDoc(documentData,$event)">{{documentData.associatedDocumentName}}</a></div>
                  <span class="col-md-6" *ngIf="documentData.associatedFolderPath != null"><b>Path :</b> {{
                    documentData.associatedFolderPath }},&nbsp;
                    <b>Status : </b>{{ documentData.associatedStatus }}</span>
                </div>
              </div>
              <div class="row mt-3">

                <div class="col-md-6" *ngIf="isShowUserBelongsToField">
                  <div>
                    <label for="email ">Belongs To User</label><span class="mandatory-symbol">*</span>
                  </div>
                  <div class="dms-search-container">
                    <input id="belongsToUser" class="form-control" type="text"
                      [(ngModel)]="documentData.belongsUserName" (click)="searchUserFunction()" />
                  </div>
                  <span *ngIf="
                      documentData.belongsUserId == null &&
                      onclickedSaveButton
                    " id="belongsToUser-required-msg" style="display: block">Please enter belongs to user</span>
                </div>
                <div class="col-md-6" *ngIf="isShowCrFields">
                  <div>
                    <label for="email">CR</label><span class="mandatory-symbol" *ngIf="isCrFeildIsMandatory">*</span>
                  </div>
                  <div class="dms-search-container">

                    <input id="cr" class="form-control" type="text" placeholder="CR"
                      [(ngModel)]="documentData.crDetails" (click)="searchCrFunction('Document')" readonly
                      style="cursor: pointer;" />
                  </div>
                  <span *ngIf="isCrFeildIsMandatory && onclickedSaveButton" id="cr-required-msg"
                    style="display: block">Please select CR</span>
                </div>

              </div>
              <div class="row mt-3" *ngIf="isShowIsBlindedFlag">
                <div class="col-md-4">
                  <div><label for="email">Is Blinded</label></div>
                  <mat-slide-toggle color="primary" [(ngModel)]="documentData.isBlinded1" [disabled]="
                      !iSBlindTheDoc || saveButtonForDocument == false
                    ">
                    <span class="active-inActive-container" *ngIf="documentData.isBlinded1 == true" [ngStyle]="
                        documentData.isBlinded1 == true
                          ? { color: 'green' }
                          : { color: '' }
                      ">Blinded</span>
                    <span *ngIf="documentData.isBlinded1 == false" [ngStyle]="
                        documentData.isBlinded1 == false
                          ? { color: 'red' }
                          : { color: '' }
                      ">Not Blinded</span>
                  </mat-slide-toggle>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Revision">
            <ng-template mat-tab-label>
              <span [ngClass]="{'active': selectedTabIndex == 1}"> Revision<span class="mandatory-symbol">*</span>
              </span>
            </ng-template>
            <div class="row" style="margin:5px">
              <div class="col-md-12">
                <div class="col-sm-11" style="margin-bottom: 1%">

                  <div class="col-sm-1 angular-editor-edit" *ngIf="!saveButtonForDocument"
                    (click)="openEditor(documentData.revisionHistory)">
                    <i style="font-size: small;"> <i class="fa-solid fa-eye"></i></i>
                  </div>
                  <st-editor [(ngModel)]="documentData.revisionHistory" [config]="!saveButtonForDocument?config1:config"
                    id="revisionHistory" [disabled]="!saveButtonForDocument" class="full-width"
                    (paste)="onPaste($event)"></st-editor>
                </div>
                <span *ngIf="
                      documentData.revisionHistory == '' ||
                      documentData.revisionHistory == null
                    " id="revisionHistory-required-msg" style="display: block">Please enter revision history</span>
              </div>
            </div>
          </mat-tab>
          <mat-tab *ngIf="isShowFlexifieldBlock">
            <ng-template mat-tab-label> Additional Details </ng-template>
            <div class="row mt-3">
              <div class="col-md-12">
                <div class="row" *ngFor="let flexifield of flexiFieldsList; let i = index" style="margin-bottom: 10px">
                  <div class="col-md-3">
                    <label for="name">{{ flexifield.fieldName }}</label><span *ngIf="flexifield.isMandatory == 'Y'"
                      class="mandatory-symbol">*</span>
                  </div>
                  <div class="col-md-9" *ngIf="
    flexifield.fieldType == 'Text Field' &&
    flexifield.fieldDatatype != 'Date' && 
    flexifield.fieldDatatype != 'Datetime'
  ">
                    <input attr.id="flexifield{{ i }}" class="input-filed-continers" type="text"
                      [(ngModel)]="flexifield.fieldDefaultValue" [disabled]="saveButtonForDocument == false" />
                    <span id="flexifield{{ i }}-required-msg" style="display: block" *ngIf="
      flexifield.fieldDefaultValue == null &&
      flexifield.isMandatory == 'Y'
    ">
                      Please enter a {{ flexifield.fieldName }}</span>
                  </div>

                  <div class="col-md-9" *ngIf="
    flexifield.fieldType == 'Text Field' &&
    flexifield.fieldDatatype == 'Date'
  ">
                    <input attr.id="flexifield{{ i }}" type="text" class="form-control data-picker-continer"
                      bsDatepicker [bsConfig]="$getDateConfig(flexifield)" [dateCustomClasses]="dateCustomClasses"
                      [(ngModel)]="flexifield.fieldDefaultValue" [disabled]="saveButtonForDocument == false" />
                    <span id="flexifield{{ i }}-required-msg" style="display: block" *ngIf="
      flexifield.fieldDefaultValue == null &&
      flexifield.isMandatory == 'Y'
    ">
                      Please enter a {{ flexifield.fieldName }}</span>
                  </div>

                  <div class="col-md-9" *ngIf="
    flexifield.fieldType == 'Text Field' &&
    flexifield.fieldDatatype == 'Datetime'
  ">
                    <input attr.id="flexifield{{ i }}" type="text" class="form-control datatime-picker-continer"
                      placement="top" bsDatepicker #datePicker="bsDatepicker"
                      [bsConfig]="$getDateTimeConfig(flexifield)" [dateCustomClasses]="dateCustomClasses"
                      [(ngModel)]="flexifield.fieldDefaultValue" [disabled]="saveButtonForDocument == false"
                      (ngModelChange)="flexifield.fieldDefaultValue != null ? onDateChange(datePicker) : ''" />

                    <span id="flexifield{{ i }}-required-msg" style="display: block" *ngIf="
      flexifield.fieldDefaultValue == null &&
      flexifield.isMandatory == 'Y'
    ">
                      Please enter a {{ flexifield.fieldName }}</span>
                  </div>
                  <div class="col-md-9" *ngIf="flexifield.fieldType == 'Large Text'">
                    <textarea attr.id="flexifield{{ i }}" type="text" class="input-filed-textarea" rows="4"
                      [(ngModel)]="flexifield.fieldDefaultValue" [disabled]="saveButtonForDocument == false"></textarea>
                    <span id="flexifield{{ i }}-required-msg" style="display: block" *ngIf="
                        flexifield.fieldDefaultValue == null &&
                        flexifield.isMandatory == 'Y'
                      ">
                      Please enter a {{ flexifield.fieldName }}</span>
                  </div>
                  <div class="col-md-9" *ngIf="flexifield.fieldType == 'Multiselect Drop Down'">
                    <mat-select matInput multiple #multiselect placeholder="Select"
                      [(ngModel)]="flexifield.selectedFlexifieldValue" [disabled]="saveButtonForDocument == false"
                      (closed)="fieldsSearchTxt=''" (click)="focusmethod('flexifieldValueSearch')"
                      (keydown.enter)="focusmethod('flexifieldValueSearch')">

                      <input type="search" id="flexifieldValueSearch" class="dropdownsearchstyle"
                        [(ngModel)]="fieldsSearchTxt" matInput placeholder="Search">

                      <div class="select-all">
                        <mat-checkbox [(ngModel)]="flexifield.multiSelection" [ngModelOptions]="{standalone: true}"
                          (change)="toggleAllFlexiSelection('multiselect', flexifield, i)">
                          Select All
                        </mat-checkbox>
                      </div>

                      <mat-option *ngFor="let item of flexifield.dropdowns | assessmentSearch : fieldsSearchTxt"
                        [value]="item.valueExp" (onSelectionChange)="onMultiflexiSelect($event, flexifield, i)">
                        {{ item.displayExp }}
                      </mat-option>
                    </mat-select>

                    <span id="flexifield{{ i }}-required-msg" style="display: block" *ngIf="
        flexifield.selectedFlexifieldValue.length == 0 &&
        flexifield.isMandatory == 'Y'">
                      Please enter a {{ flexifield.fieldName }}
                    </span>
                  </div>

                  <div class="col-md-9" *ngIf="flexifield.fieldType == 'Drop Down'">
                    <mat-select matInput placeholder="Select" [(ngModel)]="flexifield.fieldDefaultValue"
                      (closed)="fieldsSearchTxt=''" (click)="focusmethod('focusSearch')">
                      <input type="search" attr.id="flexifield{{i}}" class="dropdownsearchstyle"
                        [(ngModel)]="fieldsSearchTxt" matInput placeholder="Search">
                      <mat-option class="unselectStyle" [value]="null"
                        (onSelectionChange)="onFlexifieldSelect(flexifield,null);">Un-select</mat-option>
                      <mat-option *ngFor="let item of flexifield.dropdowns| assessmentSearch :fieldsSearchTxt"
                        (onSelectionChange)="onFlexifieldSelect(item,flexifield)" [value]="item.valueExp">
                        {{ item.displayExp }}
                      </mat-option>
                    </mat-select>
                    <span id="flexifield{{ i }}-required-msg" style="display: block" *ngIf="
                        flexifield.fieldDefaultValue == null &&
                        flexifield.isMandatory == 'Y'
                      ">
                      Please enter a {{ flexifield.fieldName }}</span>
                  </div>
                  <div class="col-md-9" *ngIf="
                      flexifield.fieldType == 'Vertical Radio Button' ||
                      flexifield.fieldType == 'Horizontal Radio Button'
                    ">
                    <mat-radio-group attr.id="flexifield{{ i }}" [(ngModel)]="flexifield.fieldDefaultValue"
                      [disabled]="saveButtonForDocument == false" [ngStyle]="
                        flexifield.fieldType == 'Vertical Radio Button'
                          ? { display: 'flex', 'flex-direction': 'column' }
                          : { display: 'inline-flex' }
                      ">
                      <mat-radio-button *ngFor="let val of flexifield.dropDownValues" [value]="val">{{ val
                        }}</mat-radio-button>
                    </mat-radio-group>
                    <span id="flexifield{{ i }}-required-msg" style="display: block" *ngIf="
                        flexifield.fieldDefaultValue == null &&
                        flexifield.isMandatory == 'Y'
                      ">
                      Please enter a {{ flexifield.fieldName }}</span>
                  </div>

                  <div class="col-md-9" attr.id="flexifield{{ i }}" *ngIf="
                      flexifield.fieldType == 'Vertical Checkbox Button' ||
                      flexifield.fieldType == 'Horizontal Checkbox Button'
                    ">
                    <section *ngFor="let val of flexifield.dropDownValues" [ngStyle]="
                        flexifield.fieldType == 'Vertical Checkbox Button'
                          ? { display: 'flex', 'flex-direction': 'column' }
                          : { display: 'inline-flex' }
                      ">
                      <mat-checkbox (change)="checkBoxChecked(flexifield, $event, val)"
                        [disabled]="saveButtonForDocument == false" [checked]="
                          flexifield.checkedCheckBoxValue.indexOf(val) != -1
                        ">{{ val }}</mat-checkbox>
                    </section>
                    <span id="flexifield{{ i }}-required-msg" style="display: block" *ngIf="
                        flexifield.checkedCheckBoxValue.length == 0 &&
                        flexifield.isMandatory == 'Y'
                      ">
                      Please enter a {{ flexifield.fieldName }}</span>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </mat-tab>

          <mat-tab *ngIf="taskStagesList.length > 0">
            <ng-template mat-tab-label>
              <span [ngClass]="{'active': selectedTabIndex == 2}"
                *ngFor="let stage of taskStagesList; let index = index">{{ stage.stageName
                }}<span *ngIf="index != taskStagesList.length - 1">/</span></span>
            </ng-template>
            <app-stage-user [data]="documentData"></app-stage-user>
          </mat-tab>
          <mat-tab *ngIf="
              documentData.documentId != undefined &&
              associatedDocumentsList.length > 0
            ">
            <ng-template mat-tab-label>
              <span>Associated Documents</span>
            </ng-template>
            <mat-tab-group selectedIndex2="0" mat-stretch-tabs class="trainingtab mat-tab-container mat-elevation-z4"
              animationDuration="0ms" (selectedTabChange)="onTabChanged2($event)" [(selectedIndex)]="selectedTabIndex2">
              <mat-tab *ngFor="
                  let type of documentTypeListOfAssosciatedDocs;
                  let i = index
                ">
                <ng-template mat-tab-label>
                  {{ type }}
                </ng-template>
                <div class="d-none table-container">
                  <table class="search-manager-table-container">
                    <th style="width: 140px">
                      <span>Document No</span>
                      <span class="fa-solid fa-filter"></span>
                    </th>
                    <th style="width: 80px">
                      <span>Version</span>
                      <span class="fa-solid fa-filter"></span>
                    </th>
                    <th style="width: 240px">
                      <span>Name</span>
                      <span class="fa-solid fa-filter"></span>
                    </th>
                    <th style="width: 240px">
                      <span>Folder Path</span>
                      <span class="fa-solid fa-filter"></span>
                    </th>
                    <th style="width: 120px">
                      <span>Effective Date</span>
                      <span class="fa-solid fa-filter"></span>
                    </th>
                    <th style="width: 120px">
                      <span>Expiration Date</span>
                      <span class="fa-solid fa-filter"></span>
                    </th>
                    <th style="width: 120px">
                      <span>Status</span>
                      <span class="fa-solid fa-filter"></span>
                    </th>
                    <tr class="data-row-container" *ngFor="let doc of getDocs(type); let idx = index">
                      <td style="
                          min-width: 140px;
                          color: blue;
                          text-decoration: underline;
                          cursor: pointer;
                        " (click)="openAssDocInViewer(doc)">
                        {{ doc.documentNo }}
                      </td>
                      <td style="min-width: 80px">{{ doc.version }}</td>
                      <td style="min-width: 240px">{{ doc.documentName }}</td>
                      <td style="min-width: 240px">{{ doc.folderPath }}</td>
                      <td style="min-width: 120px">
                        {{ doc.effectiveDate | date : uiDateFormat | uppercase }}
                      </td>
                      <td style="min-width: 120px">
                        {{ doc.expirationDate | date : uiDateFormat | uppercase }}
                      </td>
                      <td style="min-width: 120px">{{ doc.status }}</td>
                    </tr>
                  </table>
                </div>
                <div class="table-container">

                  <table class="dynamic-table-container documentTable">
                    <th
                      [ngStyle]="{'min-width': '240px', 'max-width': '240px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>Document No.</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th
                      [ngStyle]="{'min-width': '100px', 'max-width': '100px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>Version</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th
                      [ngStyle]="{'min-width': '240px', 'max-width': '240px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>Document Name</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th
                      [ngStyle]="{'min-width': '240px', 'max-width': '240px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>Folder Path</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th
                      [ngStyle]="{'min-width': '160px', 'max-width': '160px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>Effective Date</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th
                      [ngStyle]="{'min-width': '160px', 'max-width': '160px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>Expiration Date</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th
                      [ngStyle]="{'min-width': '140px', 'max-width': '140px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>Status</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <tr class="data-row-container" *ngFor="let doc of getDocs(type); let idx = index">
                      <td style="
                          min-width: 240px;
                          color: blue;
                          text-decoration: underline;
                          cursor: pointer;
                        " (click)="openAssDocInViewer(doc)">
                        {{ doc.documentNo }}
                      </td>
                      <td style="min-width: 100px">{{ doc.version }}</td>
                      <td style="min-width: 240px">{{ doc.documentName }}</td>
                      <td style="min-width: 240px">{{ doc.folderPath }}</td>
                      <td style="min-width: 120px">
                        {{ doc.effectiveDate | date : uiDateFormat | uppercase }}
                      </td>
                      <td style="min-width: 120px">
                        {{ doc.expirationDate | date : uiDateFormat | uppercase }}
                      </td>
                      <td style="min-width: 140px">{{ doc.status }}</td>
                    </tr>
                  </table>

                </div>
              </mat-tab>
            </mat-tab-group>
          </mat-tab>

          <mat-tab *ngIf="documentData.documentId != null">
            <ng-template mat-tab-label>
              <span [ngClass]="{'active': selectedTabIndex == 3}">Tags</span>
            </ng-template>
            <app-document-tags [documentData]="documentData" [type]="'Tagging'"></app-document-tags>
          </mat-tab>
          <mat-tab *ngIf="
              documentData.documentId != undefined && documentData.tagsCount > 0
            ">
            <ng-template mat-tab-label>
              <span>Tagged</span>
            </ng-template>
            <app-document-tags [documentData]="documentData" [type]="'Tagged'"></app-document-tags>
          </mat-tab>
          <mat-tab *ngIf="documentData.documentId != undefined && documentData.extensionCount > 0
            ">
            <ng-template mat-tab-label> Extensions </ng-template>
            <div>
              <app-document-extension [documentData]="documentData"></app-document-extension>
            </div>
          </mat-tab>
          <mat-tab *ngIf="
              documentData.documentId != undefined &&
              documentData.withdrawCount > 0
            ">
            <ng-template mat-tab-label> Withdrawal </ng-template>
            <div>
              <app-document-withdrawal [documentData]="documentData"></app-document-withdrawal>
            </div>
          </mat-tab>

          <mat-tab *ngIf="
              documentData.documentId != undefined &&
              documentData.destructionCount > 0
            ">
            <ng-template mat-tab-label> Destruction </ng-template>
            <div>
              <app-document-destruction [documentData]="documentData"></app-document-destruction>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>

<ng-template #searchUser>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchUserFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div id="filed-container" class="form-continer">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email ">User Name</label></div>
        <input class="search-filed-continers uppercase" type="text" placeholder="Enter User Name"
          [(ngModel)]="searchByUserName" />
        <div id="searchbyUserName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter First Name"
          [(ngModel)]="searchByFirstName" />
        <div id="firstName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Last Name"
          [(ngModel)]="searchByLastName" />
        <div id="lastName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Designation</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCode"
          (closed)="designationSearchText=''" (click)="focusSearch('focus-designation-search')">
          <input type="search" id="focus-designation-search" class="dropdownsearchstyle"
            [(ngModel)]="designationSearchText" matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onDesignationCodeSelect($event,null)">Un-select</mat-option>
          <mat-option *ngFor="let item of designationCodeDropdown | assessmentSearch : designationSearchText"
            [value]="item.valueExp" (onSelectionChange)="onDesignationCodeSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>

      </div>
      <div class="col-md-3">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode"
          (closed)="departmentSearchText=''" (click)="focusSearch('focus-department-search')">
          <input type="search" id="focus-department-search" class="dropdownsearchstyle"
            [(ngModel)]="departmentSearchText" matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onDepartmentCodeSelect($event,null)">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentCodeDropdown | assessmentSearch : departmentSearchText"
            [value]="item.valueExp" (onSelectionChange)="onDepartmentCodeSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row">
      <div class="search-button-continer" mat-dialog-actions class="btn-align">
        <button mat-stroked-button class="searchButton" (click)="searchUserGridDataFunction()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchUserGridDataFunction()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showUserSearchGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center">
          <div style="display: flex">
            <div>
              <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
            </div>
          </div>
        </th>
        <th>
          <span>User Name</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>First Name</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Last Name</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>User Full Name</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Designation</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Department</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>EmailAddress</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Manager Name</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th class="sticky-col first-col"></th>
        <tr class="data-row-container" *ngFor="
            let listOfUsersVwDetails of getOneQmsUsersVwDetailsTableData;
            let idx = index
          ">
          <td style="min-width: 80px; text-align: center">
            <div style="display: flex">
              <div [ngClass]="
                  listOfUsersVwDetails.searchUserChildCheckBoxs
                    ? 'static_icon'
                    : 'hover-menu-icons'
                ">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px">
                <input id="selectedUserCheckBox" type="checkbox" style="zoom: 1.2"
                  [checked]="listOfUsersVwDetails.searchUserChildCheckBoxs"
                  (change)="searchUserChildCheckBoxChecked($event, listOfUsersVwDetails, idx)" />
              </div>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersVwDetails.userName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.firstName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.lastName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.userFullname }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.designation }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.department }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.emailAddress }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.managerName }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="button-continer" mat-dialog-actions class="btn-align">
    <button mat-stroked-button class="addButton" (click)="addUserNameFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchUserFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #searchDocument>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchDocumentFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div id="filed-container" class="form-continer">
    <app-folder-stucture [data]="'DOCUMENT'" [type]="isAmendmentDocType"
      (valueChange)="changeInFolderStructureChild($event)"></app-folder-stucture>
  </div>
  <div class="button-continer" mat-dialog-actions class="btn-align">
    <button mat-stroked-button class="addButton" (click)="addDocumentFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchDocumentFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #confirmWithReasonPopup>
  <h2 mat-dialog-title>{{ title }}</h2>
  <div style="margin: 15px 15px">
    <div class="form-continer">
      <div class="row"
        *ngIf="buttonLabel == 'CheckOut' && (documentData.isAmendmentInProgress == 'Y' || documentData.noOfCompletedAmendment>0)">
        <div class="col-md-12">
          <div>
            <label for="reason"><span style="color: red;"><b>Note</b></span> : The linked amendment document will become
              obsolete post the revision</label>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="buttonLabel === 'Delete' && isParentDocument" style="margin-bottom: 10px;">
        <div class="col-md-12">
          <div>
            <b><span style="color:red">Warning!</span>&nbsp;Deleting the parent document will also delete all linked
              associated documents.</b>
          </div>
        </div>
      </div>
      <div class="row"
        [hidden]="buttonLabel == 'Publish' || buttonLabel =='Collaborative Review'  || buttonLabel =='Change Collaborative Reviewers' ">
        <div class="col-md-12">
          <div>
            <label for="reason"> Reason</label><span class="mandatory-symbol">*</span>
          </div>
          <textarea id="reason" rows="4" class="textarea-filed-continers" type="text" [(ngModel)]="reason"></textarea>
          <div id="reason-val-icon" class="field-icon-container"></div>
          <span id="reason-required-msg">Please enter reason</span>
        </div>
      </div>
      <div class="row" *ngIf=" buttonLabel =='Collaborative Review' ||  buttonLabel =='Change Collaborative Reviewers'">
        <div class="col-md-12">
          <div>
            <label for="reason"> Users : </label><span class="mandatory-symbol">*</span>
          </div>
          <mat-select matInput multiple placeholder="Select" #userFeild
            [ngStyle]="selectedUser ? {'cursor' : 'pointer'} : {'cursor' : 'not-allowed'}" [(ngModel)]="selectedUser"
            id="user" (closed)="userSearchText=''" (click)="focusSearch('focus-b-area-search')">
            <input type="search" id="focus-b-area-search" class="dropdownsearchstyle" [(ngModel)]="userSearchText"
              matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="isAllUsersSelected" (change)="toggleAllSelection('userFeild')">Select
                All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item1 of userDropdown | multiAssessmentSearchPipe : userSearchText"
              [value]="item1.valueExp + ''" (onSelectionChange)="onUsersSelect($event, item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <br *ngIf="buttonLabel == 'Publish' && isShowExpDate" />
      <div class="row" style="margin-top: 15px;"
        *ngIf="isShowCrFields && (buttonLabel === 'CheckOut' || documentData?.status === 'Published') && documentData?.isExtensionInProgress !== 'Y' && documentData?.isWithdrawalInProgress !== 'Y'">
        <div>
          <label for="email">CR</label><span class="mandatory-symbol" *ngIf="isCrFeildIsMandatory">*</span>
        </div>
        <div class="row-search-container">
          <input class="form-control" type="text" placeholder="Search" id="crForCheckout" [(ngModel)]="checkoutcrId"
            (click)="searchCrFunction('Checkout')" readonly style="cursor: pointer;" />
        </div>
        <span id="crForCheckout-required-msg">Please search and select CR</span>
      </div>
      <br />
      <div class="row" [hidden]="
      buttonLabel === 'Self Lock' || (buttonLabel !== 'CheckOut' && documentData.status !== 'Published')" style="height: auto;
          max-height: 200px;
          overflow-y: auto;
          margin-bottom: 10px;
        ">
        <div>
          <label for="email" *ngIf="associatedDocumentListForCheckout.length != 0">Select Associated Document For
            Checkout</label>
        </div>
        <div>

          <section *ngFor="let doc of associatedDocumentListForCheckout; let i = index"
            style="display: flex; flex-direction: column; color: black">
            <mat-checkbox
              *ngIf="doc.status!='Withdrawn' && doc.isExtensionInProgress!='Y' && doc.isWithdrawalInProgress!='Y' && doc.isDestructionInProgress!='Y' && doc.checkoutFlag=='N'"
              (change)="onChange(i, $event)" [name]="doc.documentId" [checked]="doc.checked" [value]="doc.documentId">
              <span>{{ doc.documentName }}({{ doc.documentNo }}({{doc.status}}))</span></mat-checkbox>
          </section>
        </div>
      </div>
      <br />
    </div>
    <div class="button-continer" mat-dialog-actions class="btn-align">
      <button mat-stroked-button class="addButton" (click)="confirmWithReasonFunc()">
        {{ buttonLabel }}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #publishPopup>
  <h2 mat-dialog-title>{{ title }}</h2>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <div style="margin: 15px 15px">
    <div class="form-continer">
      <div class="row" *ngIf="getOneQmsUsersTrainingsRepVwDetails.length > 0">
        <p>Please note, this document is associated with a training. The current completion rate of the training is
          shown below.</p>
        <div class="table-container">
          <div class="table-header1">
            <div class="table-cell-th1" style="min-width: 200px;">
              Training Name
            </div>
            <div class="table-cell-th1" style="min-width: 60px;">
              Version</div>
            <div class="table-cell-th1" style="min-width: 60px;">Total</div>
            <div class="table-cell-th1" style="min-width: 80px;">Pending</div>
            <div class="table-cell-th1" style="min-width: 80px;">Completed</div>
            <div class="table-cell-th1" style="min-width: 60px;">Failed</div>
            <div class="table-cell-th1" style="min-width: 80px;">Scheduled</div>
            <div class="table-cell-th1" style="min-width: 80px;">Inprogress</div>
            <div class="table-cell-th1" style="min-width: 80px;">Overdue</div>
            <div class="table-cell-th1" style="min-width: 60px;">Locked</div>
            <div class="table-cell-th1" style="min-width: 80px;">Failed Attempts</div>
            <div class="table-cell-th1" style="min-width: 70px;">Pass %</div>
          </div>
          <div class="table-row1" *ngFor="let listOfUsersData of pagedItemsMain; let idx = index;">



            <div class="table-cell1 name clickable nameAlign" style="min-width: 200px;"
              [title]="listOfUsersData.trainingName">
              {{listOfUsersData.trainingName}}
            </div>
            <div class="table-cell1  clickable valueAlign" style="min-width: 60px;">
              {{listOfUsersData.version}}
            </div>
            <div class="table-cell1 clickable valueAlign" style="min-width:60px;">
              {{listOfUsersData.total}}
            </div>
            <div class="table-cell1 clickable valueAlign" style="min-width: 80px;">
              {{listOfUsersData.pending}}
            </div>
            <div class="table-cell1 clickable valueAlign" style="min-width: 80px;">
              {{listOfUsersData.completed}}
            </div>
            <div class="table-cell1 clickable valueAlign" style="min-width:60px;">
              {{listOfUsersData.failed}}
            </div>
            <div class="table-cell1 clickable valueAlign" style="min-width: 80px;">
              {{listOfUsersData.scheduled}}
            </div>
            <div class="table-cell1 clickable valueAlign" style="min-width: 80px;">
              {{listOfUsersData.inprogress}}
            </div>
            <div class="table-cell1 clickable valueAlign" style="min-width: 80px;">
              {{listOfUsersData.overdue}}
            </div>
            <div class="table-cell1 clickable valueAlign" style="min-width:60px;">
              {{listOfUsersData.locked}}
            </div>
            <div class="table-cell1 valueAlign" style="min-width: 80px;">
              {{listOfUsersData.failedAttempts}}
            </div>
            <div class="table-cell1 valueAlignC" style="min-width:70px;">
              {{(listOfUsersData.completed / listOfUsersData.total * 100).toFixed(1)}}%
            </div>
          </div>
        </div>
        <div *ngIf="collectionSize>10">
          <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <div class="col-2 col-md-6 d-flex justify-content-end align-items-center">
            </div>
            <nav class="col-6 col-md-4 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
              1-{{ perPage }} of {{ collectionSize | number }}
              <ngb-pagination class="leftpadding" (pageChange)="setPageMain(pager.currentPage,$event)"
                [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize"
                [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
              <div ngbDropdown class="d-inline-block leftpadding">
                <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic1" ngbDropdownToggle>
                  {{perPage}}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCallMain(10)">10</button>
                  <button ngbDropdownItem (click)="paginationCallMain(20)">20</button>
                  <button ngbDropdownItem (click)="paginationCallMain(50)">50</button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <br *ngIf="getOneQmsUsersTrainingsRepVwDetails.length > 0">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-3">
              <label for="username ">Effective Date</label>
            </div>
            <div class="col-md-9">
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="documentData.effectiveDate" id="effectiveDate"
                (ngModelChange)="selectExpValue(documentData.effectiveDate)" [disabled]="!isOverrideEffectiveDate"
                [maxDate]="(followSameExpDate && tempDateExpiration)  ?  documentData.effectiveDate:documentData.expirationDate " />
              <span id="effectiveDate-required-msg">Please choose effective date</span>
            </div>
          </div>
        </div>
        <div class="col-md-6" *ngIf="isShowExpDate">
          <div class="row">
            <div class="col-md-3">
              <label for="username">Expiration Date</label>
            </div>
            <div class="col-md-9">
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="documentData.expirationDate" [disabled]="!isOverrideExpDate"
                [minDate]="documentData.effectiveDate" [maxDate]="tempDateExpiration" />
              <span id="expirationDate-required-msg">Please choose expiration date</span>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
    <div class="button-continer" mat-dialog-actions class="btn-align">
      <button mat-stroked-button class="addButton" (click)="okPublishFunc()">
        {{ buttonLabel }}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelPublishFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #publishConfirmPopup>
  <h2 mat-dialog-title>{{ title }}</h2>
  <div style="margin: 15px 15px">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">Do you still wish to proceed with publishing this document.</div>
      </div>
      <br />
    </div>
    <div class="button-continer" mat-dialog-actions class="btn-align">
      <button mat-stroked-button class="addButton" (click)="confirmWithReasonFunc()">
        {{ buttonLabel }}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelConfirmPublishFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #confirmPopup>
  <h2 mat-dialog-title>{{ title }}</h2>
  <div style="margin: 15px 15px">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">Are you sure you want to {{ buttonLabel }}?</div>
      </div>
      <br />
      <div class="row" *ngIf="buttonLabel=='Cancel Checkout' && isParentDocument ">
        <div>
          <label for="email" id="groupNameAlert"><b>Cancel Associated Documents Checkout</b></label>
          <mat-slide-toggle color="primary" [(ngModel)]="isChildCancelCheckoutFlag">
            <span class="active-inActive-container" *ngIf="isChildCancelCheckoutFlag" style="color: green;">Yes</span>
            <span *ngIf="!isChildCancelCheckoutFlag" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <br />
    </div>
    <div class="button-continer" mat-dialog-actions class="btn-align">
      <button mat-stroked-button class="addButton" (click)="confirmOkFunc()">
        {{ buttonLabel }}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelConfirmFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #confirmWithDataPopup>
  <h2 mat-dialog-title>{{ buttonLabel }}</h2>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <div style="padding: 2%">
    <div class="row">
      <div class="col-md-6" style="border-right: 1px solid black">
        <div>
          <label style="margin-left: 20%; font-weight: 600" for="status">Action</label><span
            class="mandatory-symbol">*</span>
        </div>
        <mat-radio-group id="status" class="tp-radio-group" [(ngModel)]="selectedStatus"
          style="display: flex; flex-direction: column">
          <mat-radio-button class="tp-radio-button" *ngFor="let status of statusList" [value]="status.codelistCode"
            (change)="onStatusSelect(status.codelistCode)">
            {{ status.codelistName }}
          </mat-radio-button>
        </mat-radio-group>
        <span style="margin-left: 25%" id="status-required-msg">Please select status</span>
      </div>
      <div class="col-md-6" *ngIf="isEsignRequired" style="margin-top: 2%">
        <div class="row" *ngIf="isEsignRequired">
          <div>
            <label for="username ">User Name</label><span class="mandatory-symbol">*</span>
          </div>
          <div>
            <input id="username" style="height: 80% !important" class="input-filed-continers" type="text"
              [(ngModel)]="displayUserName" disabled />
          </div>
        </div>
        <div class="row" *ngIf="(isEsignRequired && !isAdenabled)">
          <div>
            <label for="pass ">Password</label><span class="mandatory-symbol">*</span>
          </div>
          <div>
            <input id="pass" style="height: 80% !important" class="input-filed-continers"
              [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password" noCopyPaste />
            <span class="eyeicon-container eye-color" (click)="showPassword()">
              <i
                [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
            </span>
          </div>
          <span style="margin-left: 25%" id="pass-required-msg">Please enter password</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div><label for="comment">Comments</label></div>
      <div>
        <textarea rows="4" id="comment" class="textarea-filed-continers" type="text" [(ngModel)]="comments"></textarea>
      </div>
    </div>

    <div class="row" *ngIf="isShowRejectReason" style="width: 60%; margin-bottom: 1%">
      <div>
        <label for="rejectReason" *ngIf="isShowRejectReason">Reject Reason</label><span
          class="mandatory-symbol">*</span>
      </div>
      <div>
        <mat-select id="rejectReason" matInput placeholder="Select" [(ngModel)]="selectedRejectReasonValue"
          (closed)="rejectReasonSearchText=''" (click)="focusSearch('focus-reject-reason-search')">
          <input type="search" id="focus-reject-reason-search" class="dropdownsearchstyle"
            [(ngModel)]="rejectReasonSearchText" matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onRejectReasonSelect($event,null)">Un-select</mat-option>
          <mat-option *ngFor="let item of rejectReasonDropdown | assessmentSearch : rejectReasonSearchText"
            [value]="item.valueExp" (onSelectionChange)="onRejectReasonSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <span id="rejectReason-required-msg">Please select reject reason</span>
    </div>

    <div class="row" *ngIf="isReasonSignReqd" style="width: 80%; margin-bottom: 1%">
      <div>
        <label for="reasonForSignature">Reason for Signature</label><span class="mandatory-symbol">*</span>
      </div>
      <div>
        <mat-select id="rejectReason" matInput placeholder="Select" [(ngModel)]="selectedReasonValue"
          id="reasonForSignature" (closed)="reasonSearchText=''" (click)="focusSearch('focus-reason-search')">
          <input type="search" id="focus-reason-search" class="dropdownsearchstyle" [(ngModel)]="reasonSearchText"
            matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onReasonSelect($event,null)">Un-select</mat-option>
          <mat-option *ngFor="let item of reasonDropdown | assessmentSearch : reasonSearchText" [value]="item.valueExp"
            (onSelectionChange)="onReasonSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>

      </div>
      <span id="reasonForSignature-required-msg">Please select reason for signature</span>
    </div>

    <div class="row">
      <div><label for="comment">Document</label></div>
      <div>
        <input type="file" class="file-input" (change)="onConfirmFileSelected($event)" #fileUpload />
      </div>
    </div>
  </div>
  <div class="button-continer" mat-dialog-actions class="btn-align">
    <button mat-stroked-button class="addButton" (click)="confirmWithDataFunc()">
      {{ buttonLabel }}
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelConfirmWithDataFunc()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #topicPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" mat-button (click)="canceltopicPopup()">
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Documents Topics </label>
    <label class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <app-oneqms-topics [topicData]=""></app-oneqms-topics>
</ng-template>

<ng-template #searchCr>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelCrFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Search CR</label>
    <label class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div id="filed-container" class="form-continer">
    <div class="row">
      <div class="col-md-8 group-dropdown-container">
        <label for="email">Group</label><span class="mandatory-symbol">*</span>
        <div class="col-sm-6 group-dropdown-align">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedCrGroup" (closed)="groupSearchText=''"
            (click)="focusSearch('focus-group-search')" id="groupSearch">
            <input type="search" id="focus-group-search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onGroupValueSelect($event,null)">Un-select</mat-option>
            <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
              [value]="item.valueExp" (onSelectionChange)="onGroupValueSelect($event,item)">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
          <span id="groupSearch-required-msg">Please choose group to select</span>
        </div>
      </div>
    </div>
    <div class="row text-center">
      <div class="group-dropdown-align">
        <div class="search-button-continer">
          <button mat-stroked-button class="searchButton searchButton1" (click)="seachCrForDocumentsFunc()">
            <i class="fa-solid fa-magnifying-glass"></i> Search
          </button>
          <button mat-stroked-button class="cancelButton resetButton" (click)="gridResetFunction()">
            <i class="fa fa-repeat"></i> Reset
          </button>
        </div>
      </div>
    </div>
    <div class="table-container" *ngIf="isShowSearchedCrGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center"></th>
        <th>
          <span>Cr ID</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Description</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Status</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Initiator</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Owner</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>QA</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th>
          <span>Business Area</span>
          <span class="fa-solid fa-filter"></span>
        </th>
        <th class="sticky-col first-col"></th>
        <tr class="data-row-container" *ngFor="let cr of searchedCrList; let idx = index">
          <td style="min-width: 80px; text-align: center">
            <div style="display: flex">
              <div [ngClass]="
                  cr.searchCrChildCheckBoxs ? 'static_icon' : 'hover-menu-icons'
                ">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px">
                <input id="selectedUserCheckBox" type="checkbox" style="zoom: 1.2" [checked]="cr.searchCrChildCheckBoxs"
                  (change)="searchCrChildCheckBoxChecked($event, cr, idx)" />
              </div>
            </div>
          </td>
          <td class="row-data">{{ cr.crId }}</td>
          <td class="row-data">{{ cr.shortDescription }}</td>
          <td class="row-data">{{ cr.status }}</td>
          <td class="row-data">{{ cr.initiatedByUserName }}</td>
          <td class="row-data">{{ cr.ownerUserName }}</td>
          <td class="row-data">{{ cr.qaUserName }}</td>
          <td class="row-data">{{ cr.coreBusinessAreaName }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="button-continer" mat-dialog-actions class="btn-align">
    <button mat-stroked-button class="addButton" (click)="addCrFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelCrFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #infoPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="okInfo()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Warning</label>
    <label class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div style="margin: 15px 15px">
    <div class="row">
      <div class="col-md-12">
        {{ warningMsg }}
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions class="btn-align">
      <button mat-stroked-button class="addButton" (click)="okInfo()">
        OK
      </button>
    </div>
  </div>
</ng-template>
<ng-template #downloadPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDownloadFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">{{ title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <app-document-download [documentData]="documentData" (valueChange)="changeInChild($event)"></app-document-download>
</ng-template>


<ng-template #confirmPopupCoauthor>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="closeCoAuthor()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Co Author</label>
    <label class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div style="margin: 15px 15px">
    <div class="row">
      <div class="col-md-12">
        <div>
          <label for="reason"> Users : </label><span class="mandatory-symbol">*</span>
        </div>
        <mat-select matInput multiple placeholder="Select" #userFeild
          [ngStyle]="selectedUser ? {'cursor' : 'pointer'} : {'cursor' : 'not-allowed'}" [(ngModel)]="selectedUser"
          id="user" (closed)="userSearchText=''" (click)="focusSearch('focus-b-area-search')">
          <input type="search" id="focus-b-area-search" class="dropdownsearchstyle" [(ngModel)]="userSearchText"
            matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="isAllUsersSelected" (change)="toggleAllSelection('userFeild')">Select
              All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item1 of userDropdown | multiAssessmentSearchPipe : userSearchText"
            [value]="item1.valueExp + ''" (onSelectionChange)="onUsersSelect($event, item1)">
            {{ item1.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>

    <div class="button-continer" mat-dialog-actions class="btn-align">
      <button mat-stroked-button class="addButton" (click)="confirmOkCoauthor()">
        OK
      </button>
    </div>
  </div>
</ng-template>



<ng-template #angularEditorTextarea>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelAngularEditorData()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Revision</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div><br>
  <div class="row">
    <div class="col-md-12 st-editor">
      <st-editor [(ngModel)]="editorValue" [config]="config1" [spellcheck]="true"></st-editor>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelAngularEditorData()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>